// RadialHost: wires the click radial menu to world state — candidate list
// with talking/asleep status, active-push label, and push/save/delete/bio
// callbacks. Keeps GameScreen under the line limit.
import RadialMenu, { R_OUTER_SQUARE } from './RadialMenu.js';
import type { Npc, RuntimeNpc } from '../types.js';

export default function RadialHost(props: {
  radialId: string;
  x: number;
  y: number;
  npcs: Npc[];
  runtime: RuntimeNpc[];
  now: number;
  onBio: (id: string) => void;
  onPush: (fromId: string, targetId: string | null) => void;
  onSave: (id: string) => void;
  onDelete: (id: string) => void;
  onClose: () => void;
}): JSX.Element | null {
  const { radialId, npcs, runtime, now } = props;
  const self = npcs.find((n) => n.id === radialId);
  if (!self) return null;
  const rtById = new Map(runtime.map((r) => [r.npcId, r]));
  const pushId = rtById.get(radialId)?.pushTargetId ?? null;
  const pushLive = pushId != null && (rtById.get(radialId)?.pushUntil ?? 0) > now;
  // Clamp the disc fully inside the viewport (game-scale, not list-width).
  const half = R_OUTER_SQUARE / 2;
  const cx = Math.max(half + 6, Math.min(props.x, window.innerWidth - half - 6));
  const cy = Math.max(half + 6, Math.min(props.y, window.innerHeight - half - 6));
  return (
    <RadialMenu
      name={`${self.firstName} ${self.lastName}`}
      x={cx}
      y={cy}
      saved={self.savedFavorite}
      pushTargetName={pushLive ? npcs.find((n) => n.id === pushId)?.firstName ?? '?' : null}
      candidates={npcs
        .filter((n) => n.id !== radialId)
        .map((n) => {
          const r = rtById.get(n.id);
          return {
            id: n.id,
            name: `${n.firstName} ${n.lastName}`,
            status: r?.busyWith ? 'talking' : r?.restingBed ? 'asleep' : '',
          };
        })}
      onBio={() => props.onBio(radialId)}
      onPush={(targetId) => props.onPush(radialId, targetId)}
      onSave={() => props.onSave(radialId)}
      onDelete={() => props.onDelete(radialId)}
      onClose={props.onClose}
    />
  );
}
